import { render } from "./BlogCategoriesDecor.vue?vue&type=template&id=8cd21106&scoped=true"
import script from "./BlogCategoriesDecor.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesDecor.vue?vue&type=script&lang=js"

import "./BlogCategoriesDecor.vue?vue&type=style&index=0&id=8cd21106&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8cd21106"

export default script